import React, { useState, useRef } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import PropTypes from 'prop-types';

/**
 * React Hooks that make up the Join a Classroom button and modal
 *
 * @param props
 */
const JoinClassroom = (props) => {
	const {
		className,
		user,
		btnClass,
		disabled
	} = props;

	const [modal, setModal] = useState(false);
	const toggle = () => setModal(!modal);
	const inputClassUuid = useRef(null);
	const inputTeacherEmail = useRef(null);
	const [loading, setLoader] = useState(false);
	const toggleLoader = (bool) => setLoader(bool);
	const [errorMessage, setErrorMessage] = useState(false);
	const toggleErrorMessage = (message) => setErrorMessage(message);
	let hiddenClass;

	const clearErrors = function() {
		toggleLoader(false);
		toggleErrorMessage(false);
	};

	const ajaxRequest = function() {
		const url = '/code/views/ajax/users/requestToJoinClass.php';
		let xhr;
		let params = 'class_uuid=' + inputClassUuid.current.value + '&teacherEmail=' +
			inputTeacherEmail.current.value + '&student_uuid=' + user.id + '&studentName=' +
			(user.firstName + ' ' + user.lastName) + '&useSoftLimit=1';

		if (inputClassUuid.current.value !== '' && inputTeacherEmail.current.value !== '') {
			toggleLoader(true);
			toggleErrorMessage(false);

			xhr = new XMLHttpRequest();
			xhr.open(
				'POST',
				url,
				true
			);
			xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			xhr.send(params);

			xhr.addEventListener('readystatechange', () => {
				if (xhr.readyState === 4 && xhr.status === 200) {
					let response = JSON.parse(xhr.responseText);

					if (response.status) {
						// Send user to their classroom
						window.location.href = '/my/classrooms-home/' + response.class_uuid;
					} else {
						toggleErrorMessage(response.error);
						toggleLoader(false);
					}
				} else if (xhr.status === '500' || xhr.status === '404' || xhr.status === '403') {
					toggleErrorMessage('We did not get a response back from the server. Error: ' + xhr.status);
					toggleLoader(false);
				}
			});
		} else {
			toggleErrorMessage('You are missing something in the form. ' +
				'Make sure to fill out  the class code and your teacher\'s email.');
		}
	};

	if (errorMessage) {
		hiddenClass = '';
	} else {
		hiddenClass = 'd-none';
	}

	return (
		<div>
			<Button color="primary" className={'text-center ' + btnClass} onClick={toggle}
			        disabled={disabled} >
				Join a Classroom
			</Button>
			<Modal isOpen={modal} toggle={toggle} className={className}>
				<div className={'modal-header'}>
					<h3>Join a Classroom</h3>
					<button type='button' className='close' onClick={toggle} aria-label="Close">
						<span aria-hidden="true"><i className={'fa fa-times fa-2x'}>
							&nbsp;
						</i></span>
					</button>
				</div>
				<ModalBody>
					<p>Fill out the form below to request to join a classroom:</p>
					<Form>
						<FormGroup>
							<Label for={'class_uuid'}>Class Code:</Label>
							<Input innerRef={inputClassUuid} type={'text'} name={'class_uuid'} id={'class_uuid'} className={'mb-4'}
							       onChange={clearErrors} />
							<Label for={'teacherEmail'}>Teacher's Email</Label>
							<Input innerRef={inputTeacherEmail} type={'email'} name={'teacherEmail'} id={'teacherEmail'}
							       onChange={clearErrors} />
							<Input type={'hidden'} name={'student_uuid'}
							       defaultValue={user.subscriberUuid} />
							<Input type={'hidden'} name={'studentName'}
							       defaultValue={user.displayName} />
						</FormGroup>
					</Form>
					<div className={'text-danger ' +  hiddenClass } role="alert">{errorMessage}</div>
				</ModalBody>
				<ModalFooter>
					<Button color="default" className={loading ? 'disabled' : ''} onClick={ajaxRequest}>
						Join Classroom{loading ? <i className={'far fa-cog fa-spin ml-1'} aria-hidden="true"> </i> : '' }
					</Button>{' '}
					<Button color="info" onClick={toggle}>Nevermind (Nirvana)</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};

export default JoinClassroom;

JoinClassroom.propTypes = {
	className: PropTypes.string,
	user: PropTypes.object,
	btnClass: PropTypes.string,
	disabled: PropTypes.bool
};
